import ListingEdition from 'offline/model/listing/edition'

// Port of api/fuel/app/classes/filter/package/lists/listing/data/editions.php
export default {
	priority: 99,
	run: function(filter, data, config, global) {
		global.editions = {}
		if (!global.resultIndex || !global.resultIndex.length) return

		var editions = ListingEdition.collection({
			where: [
				['list_id', 'in', global.resultIndex]
			],
			order_by: {
				list_edition_date: 'desc'
			}
		})

		for (var i = 0; i < editions.length; i++) {
			var edition = editions[i]
			var listId = edition.get_list_id()
			if (!global.editions[listId]) global.editions[listId] = []
			global.editions[listId].push(edition)
		}
	}
}
